import React from 'react';
import { RContext } from '../context';
import RImage from './RImage';
/** Abstract class */
class RRegularBase extends RImage {
    /* istanbul ignore next */
    create(props) {
        throw new Error('RImage is an abstract class');
    }
    setStroke(s) {
        /* This a sneaky way around OpenLayers not supporting
         * setStroke/setFill on RegulaRBaseStyle-derived classes */
        this.stroke = s;
        this.ol = this.create(this.props);
        super.set(this.ol);
    }
    setFill(f) {
        /* This a sneaky way around OpenLayers not supporting
         * setStroke/setFill on RegulaRBaseStyle-derived classes */
        this.fill = f;
        this.ol = this.create(this.props);
        super.set(this.ol);
    }
    render() {
        super.render();
        return (React.createElement("div", { className: '_rlayers_RStyle' },
            React.createElement(RContext.Provider, { value: Object.assign(Object.assign({}, this.context), { style: this }) }, this.props.children)));
    }
}
RRegularBase.classProps = RImage.classProps.concat(['radius']);
export default RRegularBase;
//# sourceMappingURL=RRegularBase.js.map